import React from 'react';
import bmwSrc from './plus-icon.svg';
import miniSrc from './mini-btn-plus.svg';
import styles from './styles.module.scss';
import PropTypes from 'prop-types';

export const SelectButton = ({ selectTemplate, mini }) => {
  let src = mini ? miniSrc : bmwSrc;
  return (
    <button className={styles.button} onClick={selectTemplate}>
      <img alt={'plus icon'} src={src} />
    </button>
  );
};

SelectButton.propTypes = {
  selectTemplate: PropTypes.func.isRequired,
};

export default SelectButton;
